/**
 * Slice 21d — Delivered notify copy + one-shot owner_notifications insert.
 */

export const RESTOCK_DELIVERED_TYPE = "restock_delivered";

export function restockDeliveredItemSummary(
  items: { item_name?: string | null }[] | null | undefined,
  supplierNote?: string | null,
): string {
  const names = (items ?? [])
    .map((i) => (i.item_name || "").trim())
    .filter(Boolean);
  if (names.length > 0) return names.join(", ");
  const note = (supplierNote || "").trim();
  if (note) return note;
  return "Supplies";
}

/** In-app list body (two lines). */
export function restockDeliveredMessage(propertyName: string, itemSummary: string): string {
  return `${propertyName} · ${itemSummary}\nCleaners will pick up and update count`;
}

export function restockDeliveredToastTitle(propertyName: string): string {
  return `${propertyName} · Delivered`;
}

export const RESTOCK_DELIVERED_TOAST_SUB = "Cleaners update count on next clean";

export function restockDeliveredEmailSubject(propertyName: string): string {
  return `Delivered · ${propertyName}`;
}
